module.exports = __webpack_public_path__ + "static/company-default-7a5e509071cadc4e1cd6def10cd00ab9.jpg";